import "./App.css";
import Homepage from "./pages/homepage";
import Cdr from "./pages/cdr";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Realtime from "./pages/realtime";
import ManageGroupsPage from "./pages/manage-groups";
import StatsPage from "./pages/stats";
import React, { useState } from "react";
import LoginPage from "./pages/login";
import TagsPage from "./pages/tags";
import ApiPage from "./pages/api";
import Login from "./components/login/Login";
import ManageUsersPage from "./pages/manage-users";

function setToken(userToken) {
  sessionStorage.setItem("tokenStats", JSON.stringify(userToken));
}

function getToken() {
  const tokenString = sessionStorage.getItem("tokenStats");
  console.log(tokenString);
  return tokenString;
}

function App() {
  const tokenStats = getToken();

  if (!tokenStats) {
    return <Login setToken={setToken} />;
  }

  return (
    <div className="app">
      <Routes>
        <Route path="/home" element={<Homepage />}></Route>
        <Route path="/cdr" element={<Cdr />}></Route>
        <Route path="/realtime" element={<Realtime />}></Route>
        <Route
          path="/realtime-manage-groups"
          element={<ManageGroupsPage />}
        ></Route>
        <Route path="/stats" element={<StatsPage />}></Route>
        <Route path="/tags" element={<TagsPage />}></Route>
        <Route path="/api" element={<ApiPage />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/manageUsers" element={<ManageUsersPage />}></Route>
      </Routes>
    </div>
  );
}

export default App;
